import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/xc/dev/digimaker-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import TreeNode from './TreeNode';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "treenode"
    }}>{`TreeNode`}</h1>
    <p>{`TreeNode fetches data from server and render them in a tree.`}</p>
    <Props table={true} of={TreeNode} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      